import { useMediaQuery } from '@sparkai/hooks'
import { useEffect } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
import { shallow } from 'zustand/shallow'

import { Button } from '../General/Button'
import { Icon } from '../Icon'
import { Modal } from '../Modal'
import { MenuLink } from '../Navigation/MenuLink'
import { Shortcut } from '../Shortcut'
import { SearchForm } from './Form'
import { SearchResults, useSearchStore } from './useSearchStore'

type SearchModalProps = {
  data?: SearchResults
}

export function SearchModal({ data }: SearchModalProps) {
  const { isMobile } = useMediaQuery()

  const { isOpen, openSearch, closeSearch, setResults } = useSearchStore(
    (state) => ({
      isOpen: state.isOpen,
      openSearch: state.openSearch,
      closeSearch: state.closeSearch,
      setResults: state.setResults,
    }),
    shallow
  )

  useEffect(() => {
    setResults(data || { engagements: [], operators: [], orgs: [], programs: [] })
  }, [data, setResults])

  useHotkeys(
    isMac ? 'meta+k' : 'ctrl+k',
    () => {
      !isOpen && openSearch()
    },
    { preventDefault: true }
  )

  return (
    <div className='Search'>
      {isMobile && (
        <Button
          variant='unstyled'
          data-testid='search-btn'
          className='block p-2 lg:hidden'
          onClick={openSearch}
        >
          <Icon name='magnifying-glass-solid' className='h-6 w-6 text-brand-gray-500' />
        </Button>
      )}

      {!isMobile && (
        <MenuLink
          label='Search'
          icon='magnifying-glass-solid'
          rightAddon={
            <div className='inline-flex gap-1'>
              <Shortcut value={isMac ? '⌘' : 'Ctrl'} />
              <Shortcut value={'K'} />
            </div>
          }
          variant='primary'
          className='hidden lg:flex'
          data-testid='search-btn'
          onClick={openSearch}
        />
      )}

      <Modal className='z-[99999]' isOpen={isOpen} closeModal={closeSearch}>
        <SearchForm />
      </Modal>
    </div>
  )
}

const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
